var isPage = "";
let Block = {
	top: 0,
	id: ""
}
let blocks = [];
let Animate = {
	top: 0,
	show: 0
}
let animations = [];

let fixed_image = {
	w: 0,
	h: 0,
	top: 0,
	fin: 0,
	total: 0
}
let camera = {
	y: 0,
	z: 0,
	diffY: 0
}
var common = {
	scrollPos: 0,
	scrollAim: 0,
	scrollDiff: 0,
	beforeW: 0,
	isSmallScreenBefore: true,
	init: ()=>{
		var resizeFlag;
		var resizeTimer = null;
		var $body = $("body");
		common.setLanguage();
		common.resize();
		common.nav();
		setTimeout(function(){
			common.noIntervalResize();
			common.resize();
			if(isPage === "top"){
				home.init();
			}else{
				$("body").removeClass("disable");
			}
		}, 600);
		
		if(isPage === "accessories"){
			accessories.init();
		}else{
			if(isPage === "cinemacamera"){
				achievement.init();
			}
			if(isPage === "function"){
				functions.init();
			}
			let scrlID = null;
			const INTERVAL = 500;
			let scrlEnd = function(){
				if( $html.classList.contains("scroll") ){
					$html.classList.remove("scroll");
					if(!isSmallScreen){
						$(".img_kv figure").css({
							"transform": `translate3d(0, 0px, 0px)`
						});
					}
				}
				scrlID = null;
			}
			let scrll = $(document).off("scroll touchmove").on("scroll touchmove", function(){
				clearTimeout(scrlID);
				if( !$html.classList.contains("scroll") ){
					$html.classList.add("scroll");
				}
				scrlID = setTimeout(scrlEnd, INTERVAL);
				common.scrl();
				common.kvScroll();
			});
		}
		
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.noIntervalResize();
			common.resize();
			resizeTimer = null;
		};

		$(window).off("resize").on("resize",function(){
			if(!$body.hasClass("resize")){
				$body.addClass("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		});
	},
	setLanguage: function(){
		let path = location.pathname;
		let pathArry = path.split("/");
		let lang = pathArry[1];
		if(lang === "jp"){
			pathArry[1] = "en";
		}else if(lang === "en"){
			pathArry[1] = "jp";
		}
		let url = pathArry.join("/");
		if(lang === "jp"){
			$("footer .lang li").eq(1).find("a").attr("href", url);
		}else{
			$("footer .lang li").eq(0).find("a").attr("href", url);
		}
		//console.log(pathArry, url);	
	},
	nav: ()=>{
		$("#list_page_nav li a").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			gotoLink(url);
		});
		$(".nav_fplfp li a").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			gotoLink(url);
		});
		$("footer .lang li a").not("active").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			gotoLink(url);
		})
		function gotoLink(url){
			$html.classList.add("moving_page");
			
			setTimeout(function(){
				location.href = url;	
			}, 800);
		}
		$("a.btn_toggle_menu").off().on("click", function(){
			let $header = $("header");
			if( !$header.hasClass("show_menu") ){
				$header.addClass("show_menu");
			}else{
				$header.removeClass("show_menu");
			}
		});
		
		//
		$(".nav_page li a").off().on("click", function(){
			let idx = $(".nav_page li a").index(this);
			let posY = $(".block_feature").eq(idx).offset().top - $("header").height();
			common.scrollToPosition(posY, 1000);
		});
		if(isPage === "top"){
			$(".feature_imgs li a").off().on("click", function(){
				modal.current = $(".feature_imgs li a").index(this);
				modal.init();
			});
		}
	},
	resize: ()=>{
		var winW = window.innerWidth;
		var winH = window.innerHeight;
		var $body = $("body");
		if (window.matchMedia('all and (min-width : 864px)').matches) {
			isSmallScreen = false;
		} else if(window.matchMedia('all and (min-width : 0px)').matches) {
			isSmallScreen = true;
		}
		if(isPage === "top"){
			home.resize();
			
			$(".pixel_content").css({
				"height": winW*0.86875 + "px"
			});
			
			//fit_cameraのpadding-topと画像のトップが同じ位置にくるように
			//scaleを算出
			let ratio = 0;
			
			if(isSmallScreen){
				$(".block_kv_sp").css({
					"height": $("#fp_lead").offset().top*1.1 + "px"
				});
				fixed_image.w = $(".screen figure").width();
				fixed_image.h = Math.floor( fixed_image.w*640/960 );
				fixed_image.top = $("#fpl_able .content").offset().top;
				fixed_image.paddingtop = (winH - $(".img_camera").height())/2;
				
				//カメラを画面中央に
				$("#camera_pixel .block_inner").css({
					"padding-top": fixed_image.paddingtop + "px"
				})
				if( common.beforeW != winW ){
					ratio = $("#fp_main").height() / $("#fit_camera .screen").outerHeight();
				}
			}else{
				$("#fp_main").css({
					"height": ""
				});
				fixed_image.w = $(".screen figure").width();
				fixed_image.h = Math.floor( fixed_image.w*1280/1920 );
				fixed_image.top = $("#fpl_able .content").offset().top;
				fixed_image.paddingtop = (winH - $(".img_camera").height())/2;
				$(".block_kv").css({
					"height": ""
				});
				//カメラを画面中央に
				$("#camera_pixel .block_inner").css({
					"padding-top": fixed_image.paddingtop + "px"
				})
				ratio = $(window).width()*1.6 / $("#fit_camera .screen").width();
			}
			
			fixed_image.ratio = ratio;
			if( !$("#camera_pixel").hasClass("show_camera") ){
				$("#fit_camera .wrap_camera").css({
					"transform": `scale(${ratio})`
				});
			}
			
			//let rh = $("#fit_camera .screen").outerHeight()*ratio + winH/10;
			let rh = $("#fit_camera .screen").outerHeight()*ratio
			//総スクロールpx
			fixed_image.total 	= (rh + fixed_image.paddingtop);
			$("#wrap_camera_pixel").css({
				"height": fixed_image.total + "px"
			})
			fixed_image.fin 	= fixed_image.top + fixed_image.total - winH;
			
			if( !$("#camera_pixel").hasClass("showcamera") ){
				common.scrl();
			}
			$("#startline").css({
				"top": fixed_image.top + "px"
			})
			$("#endline").css({
				"top": fixed_image.fin + "px"
			})
			/**/
			//console.log($("#camera_pixel").outerHeight(), fixed_image);
		}
		
		if(isPage === "cinemacamera"){
			if(isSmallScreen){
				accordionH.close 	= window.innerWidth*0.72;
			}else{
				accordionH.close 	= window.innerWidth*0.10625;
			}
			accordionH.open 	= $(".wrap_accordion_col2 .list_col2").height();
			if( $(".wrap_accordion_col2").hasClass("active") ){
				$(".wrap_accordion_col2").css("height", accordionH.open + "px");
			}else{
				$(".wrap_accordion_col2").css("height", accordionH.close + "px");
			}
		}
		common.checkBlock();
		setTimeout(function(){
			if($body.hasClass("resize")){
				$body.removeClass("resize");
			}
		},300);
	},
	noIntervalResize: function(){
		let winW = $(window).width();
		if(isPage === "top"){
			if(isSmallScreen != common.isSmallScreenBefore){
				if (window.matchMedia('all and (min-width : 864px)').matches) {
					$("#bg_digest_movie").attr("src", "/jp/special/fp-series/assets/images/fp_series/fpable/fpl_function_pc.mp4");
				} else if(window.matchMedia('all and (min-width : 0px)').matches) {
					$("#bg_digest_movie").attr("src", "/jp/special/fp-series/assets/images/fp_series/fpable/fpl_function_sp.mp4");
				}
			}
		}
		//console.log(common.isSmallScreenBefore, isSmallScreen);
		common.isSmallScreenBefore = isSmallScreen;
	},
	checkBlock: function(){
		blocks = [];
		$('[data-block]').each(function(i){
			let _b = object(Block);
			_b.top 	=  Math.floor( $(this).offset().top );
			
			if(i === 0){
				_b.stop = 0;
			}else if(i === 1){
				_b.stop = Math.floor( $(this).find("h2").offset().top );
			}else{
				_b.stop = Math.floor( $(this).find(".sub_ttl").offset().top );
			}
			_b.id 	= $(this).attr("id");
			blocks.push(_b);
		});
		animations = [];
		$(".a").each(function(){
			let _a 	= object(Animate);
			_a.top 	= Math.floor( $(this).offset().top );
			_a.show = Math.floor( _a.top + window.innerHeight/3 );
			animations.push(_a);
		});
		//console.log(blocks);
	},
	scrollToPosition: (posY, duration) =>{
		var $page 	= $("html,body"),
			ease 	= "easeInOutCubic";
		$page.animate({
			scrollTop : posY + "px"
		},{
			"duration" 	: duration,
			"easing" 	: ease,
			"complete"	: function(){
			}
		});
	},
	scrl: () =>{
		var topD 	= $(document).scrollTop(),
			btmD 	= topD + $(window).height(),
			center 	= Math.floor( topD + $(window).height()/2 ),
			alen = animations.length,
			blen = blocks.length;
		let scrollTop = 0;
		if(isPage === "top"){
			scrollTop = $("#fp_concept_movie").offset().top;
		}else if(isPage === "cinemacamera"){
			scrollTop = $("#types").offset().top;
		}else{
			scrollTop = window.innerHeight;
		}
		if(topD >= scrollTop){
			if( !$html.classList.contains("scrolled") ){
				$html.classList.add("scrolled");
			}
		}else{
			if( $html.classList.contains("scrolled") ){
				$html.classList.remove("scrolled");
			}
		}
		
		//ナビゲーションの表示非表示 ------------------------------------
		if(topD < 50){
			if( $html.classList.contains("down") ){
				$html.classList.remove("down");
			}
		}else{
			if(topD > common.scrollPos){
				if(common.scrollAim === "up"){
					common.scrollDiff = 0;
					if( $html.classList.contains("up") ){
						$html.classList.remove("up");
					}
				}
				common.scrollAim = "down";
				common.scrollDiff++;
				if(common.scrollDiff >= 6){
					if( !$html.classList.contains("down") ){
						$html.classList.add("down");
						$("header").removeClass("show_menu");
					}
				}
			}else if(topD < common.scrollPos){
				if(common.scrollAim === "down"){
					common.scrollDiff = 0;
					if( $html.classList.contains("down") ){
						$html.classList.remove("down");
					}
				}
				common.scrollAim = "up";
				common.scrollDiff--;
				if(common.scrollDiff <= -6){
					if( !$html.classList.contains("up") ){
						$html.classList.add("up");
					}
				}
			}
		}
		
		for(var b = 0; b < blen; b++){
			if(b === blen-1){
				if(center >= blocks[b].stop){
					activeBlock(b);
				}
			}else{
				if(center >= blocks[b].stop && center < blocks[b + 1].stop){
					activeBlock(b);
				}
			}
		}
		function activeBlock(b){
			let $b = $('[data-block]').eq(b);
			if( !$b.hasClass("active") ){
				$('[data-block]').removeClass("active");
				$b.addClass("active");
				$(".indicator li a").removeClass("active");
				$(".indicator li").eq(b).find("a").addClass("active");
			}
		}
		//アニメーション ------------------------------------
		for(var i = 0; i < alen; i++){
			if(btmD >= animations[i].show){
				activeAnimate(i);
			}
		}
		function activeAnimate(i){
			let $a = $(".a").eq(i);
			if( !$a.hasClass("animate") ){
				$a.addClass("animate");
				if( $a.attr("id") === "crop_zoom" ){
					setTimeout(function(){
						cropZoom.init();
					}, 600);
				}
				if( $a.attr("id") === "follow" ){
					setTimeout(function(){
						ytMovie.play();
					}, 200);
				}
				setTimeout(function(){
					$a.addClass("animated");
				}, 1000);
			}
		}
		
		
	},
	mouseCursor: function(){
		window.document.addEventListener("mousemove", getMousePos, false);
		function getMousePos(e){
			mouse[0] = e.clientX;
			mouse[1] = e.clientY;
		}
	},
	kvScroll: function(){
		var topD 	= $(document).scrollTop(),
			btmD 	= topD + $(window).height();
		if(!isSmallScreen){
			if( $(".block_kv").hasClass("scaled") ){
				let scrlDiff = topD - common.scrollPos;
				//diffとそもそものyの位置をどうミックスするか考える
				//console.log(scrlDiff);
				if(scrlDiff > 10){
					camera.diffY = scrlDiff;
				}else{
					camera.diffY = 0;
				}
				$(".img_kv figure").css({
					"transform": `translate3d(0, ${ camera.diffY }px, 0px)`
				});
			}
		}
		if(isPage === "top"){
			var movePx 	= 0;
			var scrollH = 0;
			var currentY = 0;
			let endPos 	= 0;
			let center = 0;
			
			if(isSmallScreen){
				movePx 	= $(window).height()*0.24;
				scrollH = ($("#fp_lead").offset().top - $(window).height());
				currentY = movePx/scrollH*topD;
				if( currentY <= movePx){
					//console.log(movePx, scrollH, currentY);
					//currentY = movePx;
					//console.log(topD, scrollH)
					/*
					$(".block_kv_sp .img_kv").css({
						"transform": `translate3d(0, ${ (topD - scrollH)*-1 }px, 0px)`
					});
					*/
					if( $(".block_kv_sp").hasClass("scrolled") ){
						$(".block_kv_sp").removeClass("scrolled");
					}
					$(".block_kv_sp .img_kv figure").css({
						"transform": `translate3d(0, ${ -currentY }px, 0px)`
					});
				}else{
					if( !$(".block_kv_sp").hasClass("scrolled") ){
						$(".block_kv_sp").addClass("scrolled");
					}
				}
				endPos 	= $(".fp_lead_inner").offset().top + $(window).height()/3;
				
			}else{
				movePx 	= ( $("#fp_main").height() - $(".img_kv").height() )/2 + parseInt( $(".img_kv").css("top").replace("px", "")*.5 ) *-1;
				scrollH = $("#fp_main").height();
				currentY = movePx *(topD/scrollH);
				if( currentY >= movePx){
					currentY = movePx;
				}
				center = topD + scrollH/2;
				endPos 	= $("#fp_concept_movie").offset().top;
				
				if($(".img_kv").offset().top >= endPos){
					if( !$(".block_kv").hasClass("remove") ){
						$(".block_kv").addClass("remove");
					}
				}else{
					if( $(".block_kv").hasClass("remove") ){
						$(".block_kv").removeClass("remove");
					}
					//main
					let mainH = $("#fp_main").height()*.3;
					if(topD < $("#main").height() ){
						let current = 1 - (topD*.64/mainH);
						if(current < 0.64){
							current = 0.64;
							if( !$(".block_kv").hasClass("scaled") ){
								setTimeout(function(){
									$(".block_kv").addClass("scaled");
								}, 200);
							}
						}else{
							if( $(".block_kv").hasClass("scaled") ){
								$(".block_kv").removeClass("scaled");
							}
							$(".img_kv").css({
								"transform": `scale(${camera.z})`
							});
							if(current === 1){
								if( !$(".block_kv").hasClass("start") ){
									$(".block_kv").addClass("start");
									/*
									$(".wrap_kv").css({
										"transform": `scale(1.015)`
									});
									*/
									setTimeout(function(){
										/*
										$(".wrap_kv").css({
											"transform": `scale(1)`
										});
										*/
										$(".block_kv").removeClass("start");
									}, 400);
								}
							}
							
						}
						camera.z 	= current;
						$(".img_kv").css({
							"transform": `scale(${camera.z})`
						});
					}
				}
				
			}
			
			//camera
			if( topD >= fixed_image.top && topD < fixed_image.fin){
				if( !$html.classList.contains("fixed_image") ){
					$html.classList.add("fixed_image");
					$html.classList.remove("fixed_to_bottom");
				}
				let ratio = fixed_image.ratio;
				let diff = topD - fixed_image.top;
				let totalH = fixed_image.total*.95 - window.innerHeight;
				let per = 1 - (diff/totalH)*1.2;
				let currentRatio = ratio*per;
				if(currentRatio < 2){
					if( !$("#camera_pixel").hasClass("show_camera") ){
						$("#camera_pixel").addClass("show_camera");
					}
				}else{
					if( $("#camera_pixel").hasClass("show_camera") ){
						$("#camera_pixel").removeClass("show_camera");
					}
				}
				if(currentRatio < 1.2){
					if( !$(".txt_camera").hasClass("animate") ){
						$(".txt_camera").addClass("animate");
					}
					if(currentRatio < 1){
						currentRatio = 1;
					}
				}else{
					if( $(".txt_camera").hasClass("animate") ){
						$(".txt_camera").removeClass("animate");
					}
				}
				$(".wrap_camera").css({
					"transform": `scale(${currentRatio})`
				});
				//console.log(totalH, diff, ratio, currentRatio);
			}
			if(topD < fixed_image.top){
				if( $html.classList.contains("fixed_image") ){
					$html.classList.remove("fixed_image");
					$(".wrap_camera").css({
						"transform": `scale(${fixed_image.ratio})`
					});
				}
			}
		}
		common.scrollPos = topD;
	}
}
document.addEventListener('DOMContentLoaded', function () {
	isPage = $("body").attr("id");
	common.init();
});